import { login, getUserInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
    token: getToken(),
    userInfo: {},
    roles: [],
    permissions: []
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo
        // 将用户id和real_name存储到缓存中
        if (userInfo && userInfo.id) {
            localStorage.setItem('user_id', userInfo.id)
        }
        if (userInfo && userInfo.real_name) {
            localStorage.setItem('user_real_name', userInfo.real_name)
        }
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    }
}

const actions = {
    // 用户登录
    login({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            login({ username: username.trim(), password: password })
                .then(response => {
                    const { access_token, user_info, expires_in } = response.data
                    commit('SET_TOKEN', access_token)
                    setToken(access_token, expires_in)
                    commit('SET_USER_INFO', user_info)
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 获取用户信息
    getInfo({ commit }) {
        return new Promise((resolve, reject) => {
            getUserInfo()
                .then(response => {
                    const { data } = response
                    if (!data) {
                        reject('验证失败，请重新登录')
                    }

                    const { permissions, roles } = data

                    // 验证返回的roles是否非空数组
                    if (!roles || roles.length === 0) {
                        reject('用户角色为空')
                    }

                    commit('SET_ROLES', roles)
                    commit('SET_PERMISSIONS', permissions)
                    commit('SET_USER_INFO', data)
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 用户登出
    logout({ commit }) {
        return new Promise((resolve) => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            
            // 清除用户id和real_name缓存
            localStorage.removeItem('user_id')
            localStorage.removeItem('user_real_name')

            // 重置路由（需要动态路由支持）
            // dispatch('tagsView/delAllViews', null, { root: true })

            resolve()
        })
    },

    // 重置token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            // 清除用户id和real_name缓存
            localStorage.removeItem('user_id')
            localStorage.removeItem('user_real_name')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}